import { addMinutes } from 'date-fns';

/** Proposals and unconfirmed challenges stay this long after start. Overlay SQL uses the same window. */
export const GATHERING_VISIBLE_AFTER_START_MINUTES = 30;

const toDate = (value: Date | string): Date => (value instanceof Date ? value : new Date(value));

export const getSuggestionVisibleUntil = (start: Date | string): Date => {
  return toDate(start);
};

export const getProposalVisibleUntil = (start?: Date | string | null): Date => {
  if (start == null) {
    return new Date(NaN);
  }

  const resolved = toDate(start);
  if (Number.isNaN(resolved.getTime())) {
    return resolved;
  }

  return addMinutes(resolved, GATHERING_VISIBLE_AFTER_START_MINUTES);
};

export const getGambitVisibleUntil = (gambit: {
  start?: Date | string | null;
  end: Date | string;
  isConfirmed?: boolean | null;
}): Date => {
  if (gambit.isConfirmed) {
    return toDate(gambit.end);
  }

  if (gambit.start != null) {
    const start = toDate(gambit.start);
    if (!Number.isNaN(start.getTime())) {
      return addMinutes(start, GATHERING_VISIBLE_AFTER_START_MINUTES);
    }
  }

  return toDate(gambit.end);
};

export const isVisibleAt = (visibleUntil: Date | string, now: Date): boolean => {
  return toDate(visibleUntil).getTime() > now.getTime();
};
